import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Button } from "@material-ui/core";

const Dash_Pumps = () => {
  const history = useHistory();

  return (
    <div style={{}} className="main-d-vrf">
      <Link to="/">
        <Button
          style={{
            position: "absolute",
            top: "12%",
            left: "18%",
            zIndex: 9999999,
            borderRadius: "15px",
            backgroundColor: "#fff",
            border: "3px solid rgba(238, 200, 108, 0.99)",
            fontWeight: 600,
          }}
          className=" movebuttons"
          variant="contained"
        >
          Geri
        </Button>
      </Link>
      <section style={{ width: "100%", minHeight: "100vh" }}>
        <div
          style={{
            width: "95%",
            height: "80%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            padding: "0 4% ",
            marginTop: "25%",
          }}
          className="btn-group"
        >
          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // black'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/hidrofor");
            }}
          >
            Hidrofor
          </button>

          <button
            style={{
              backgroundColor: "rgb(237, 188, 69)",
              color: "rgb(45, 45, 45)",
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "3px solid rgb(67, 51, 22)",
              borderRadius: "16px",
              padding: "10px",
              fontSize: "19px",
              fontWeight: "600",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              userSelect: "none",
              maxHeight: "120px",
              width: "240px",
              transition: "0.3s",
              // Eklenen özellik: Hover durumunda arka plan rengini değiştir
              ":hover": {
                backgroundColor: "black",
                // YENI_RENK'i değiştirerek istediğiniz hover rengini ekleyin
              },
            }}
            onClick={() => {
              history.push("/pumps");
            }}
          >
            Pompalar
          </button>
        </div>
      </section>
    </div>
  );
};

export default Dash_Pumps;
